import React from 'react';
import styled from 'styled-components';

import {
  FacebookShareButton,
  WhatsAppShareButton,
  TelegramShareButton,
  LinkedinShareButton,
  CopyLinkButton,
} from '../../buttons';
import ShareCount from './ShareCount';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${props => (props.vertical ? 'column-reverse' : 'row')};
`;

const ActionsContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: ${props => (props.vertical ? 'column' : 'row')};
  > *:first-of-type {
    margin: ${props => props.vertical && '30px 0 20px'};
  }
  > * {
    margin: ${props => (props.vertical ? '20px 0' : '0 24px 0 0')};
  }
  .SocialMediaShareButton {
    display: flex;
  }
`;

// TODO change hostName based on ENV
const ActionBar = props => {
  const { path, vertical, shareCount } = props;
  return (
    <Container vertical={vertical}>
      <ActionsContainer vertical={vertical}>
        <ShareCount count={shareCount} />
        <FacebookShareButton url={`https://blog.seedly.sg${path}`} size="22" />
        <LinkedinShareButton url={`https://blog.seedly.sg${path}`} size="22" />
        <WhatsAppShareButton url={`https://blog.seedly.sg${path}`} size="22" />
        <TelegramShareButton url={`https://blog.seedly.sg${path}`} size="23" />
        <CopyLinkButton url={`https://blog.seedly.sg${path}`} size="23" />
      </ActionsContainer>
    </Container>
  );
};

export default ActionBar;
